import React from 'react';

const TiktokIcon = ({ color = '#f2f2f2' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g>
        <path
          d="M21 9.96533C19.3294 9.96933 17.6997 9.44833 16.3413 8.47594V15.2577C16.3408 16.5138 15.9569 17.7398 15.2409 18.7717C14.5248 19.8037 13.5108 20.5925 12.3344 21.0326C11.1579 21.4727 9.87516 21.5432 8.6576 21.2346C7.44004 20.926 6.34571 20.253 5.52095 19.3057C4.69618 18.3583 4.18029 17.1818 4.04225 15.9333C3.90421 14.6849 4.15061 13.424 4.74849 12.3194C5.34638 11.2148 6.26725 10.319 7.38798 9.75184C8.50871 9.18469 9.77588 8.97322 11.02 9.14569V12.5567C10.4507 12.3776 9.83935 12.383 9.27327 12.5721C8.70719 12.7612 8.21533 13.1243 7.86794 13.6097C7.52055 14.095 7.33539 14.6776 7.33891 15.2745C7.34243 15.8713 7.53443 16.4517 7.88752 16.9329C8.2406 17.4141 8.7367 17.7714 9.30497 17.9538C9.87324 18.1363 10.4846 18.1345 11.0518 17.9487C11.619 17.7629 12.113 17.4027 12.4632 16.9194C12.8134 16.4361 13.002 15.8546 13.002 15.2577V2H16.3413C16.339 2.282 16.3626 2.56361 16.4119 2.84127C16.5279 3.46112 16.7692 4.05078 17.1209 4.57418C17.4726 5.09759 17.9275 5.54374 18.4575 5.88533C19.2117 6.38399 20.0959 6.64977 21 6.64958V9.96533Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath>
          <rect
            width="17"
            height="19.4286"
            fill={color}
            transform="translate(4 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TiktokIcon;
